// External
import React, { Component, Fragment } from 'react';
import ReactDOMServer from 'react-dom/server.browser';
import _get from 'lodash.get';

// Internal
import Button from '../../components/button';
import NavBar from '../../components/nav-bar';
import TableInput from '../../components/table-input';
import VehicleInfo from '../../components/vehicle-info';
import * as Api from '../../utils/api';
import * as Auth from '../../utils/auth';
import styleText from './style-text';
import './styles.css';
import dacoLogo from "../../assets/images/daco_logo.svg";
import dacoWatermark from "../../assets/images/vectorpaint.svg";

const $ = window.$;

/**
 * Gets user accounts from the local storage and set as selected the first one.
 * @returns {*}
 */
const getAccounts = () => {
  const accounts = Auth.getUser().accounts.data;
  accounts[0].isSelected = true;

  return accounts;
};

class VehiclesPage extends Component {
  static headers = ['Vehículo', 'Número de Inventario', 'Millage', 'Tablilla', 'Precio'];

  static newVehicleDefaults = {
      make: '',
      model: '',
      vin: '',
      year: null,
      numberOfInventory: '',
      mileage: '',
      price: 0,
      clapBoard: '',
    };

  state = {
    vehicles: {},
    accounts: getAccounts(),
    search: '',
    accountId: null,
    newVehicle: VehiclesPage.newVehicleDefaults,
    newVehicleSelected: false,
  };

  componentDidMount() {
    const vehicles = {};

    this.state.accounts.forEach(account => {
      vehicles[account.id] = []
    });

    this.setState({ vehicles: vehicles, accountId: this.state.accounts[0].id });

    this.fetchVehicles(this.state.accounts[0].id);

    window.requestAnimationFrame(() => {
      $('.dropdown-trigger').dropdown({constrainWidth: false, coverTrigger: false});
    });
  }

  addVehicles = (accountId, vehicles) => {
    const sanitizedVehicles = vehicles.map(vehicle => {
      vehicle.clapBoard = vehicle.clapBoard || '';
      vehicle.numberOfInventory = vehicle.numberOfInventory || '';
      vehicle.mileage = vehicle.mileage || '';

      return vehicle;
    });

    this.setState((oldState) => ({
      vehicles: {
        ...oldState.vehicles,
        [accountId]: [
          ...oldState.vehicles[accountId],
          ...sanitizedVehicles
        ]
      }
    }));
  };

  fetchVehicles(accountId, nextPage) {
    this.loadableFunction(() => {
      return Api.vehicles(accountId, nextPage)
        .then(response => {
          if (response.status === 200) {
            this.addVehicles(accountId, response.data);
            const nextUrl = _get(response, 'meta.pagination.links.next');

            if (nextUrl) {
              this.fetchVehicles(accountId, nextUrl);
            }
          } else if (response.status === 401) {
            this.logOutUser();
          }
        })
        .catch(console.log);
    });
  }

  handleItemClick = ({ id }) => {
    this.setState((oldState) => {
      return oldState.vehicles[this.state.accountId].map((vehicle) => {
        if (id === vehicle.id) {
          vehicle.isSelected = !(vehicle.isSelected || false);
        }

        return vehicle;
      });
    })
  };

  handleNewVehicleClick = () => {
    this.setState({newVehicleSelected: !this.state.newVehicleSelected});
  };

  isNewVehicleSelected = () => {this.state.newVehicleSelected};

  isItemSelected = (id) => this.state.vehicles[this.state.accountId].filter(vehicle => vehicle.id === id && vehicle.isSelected).length === 1;

  handleClearSelection = (event) => {
    event.preventDefault();
    const newVehicles = {
      ...this.state.vehicles,
      [this.state.accountId]: this.state.vehicles[this.state.accountId].map(vehicle => ({
        ...vehicle,
        isSelected: false
      }))
    };

    this.setState({
      vehicles: newVehicles,
      newVehicle: VehiclesPage.newVehicleDefaults,
      newVehicleSelected: false
    });
  };

  getSelectedItems = () => {
    return this.state.vehicles[this.state.accountId].filter(vehicles => vehicles.isSelected);
  };

  areItemsSelected = () => this.getSelectedItems().length !== 0;

  getPdfDocument = ({html, styles = '', fullHeight = false}) => {
    return `
      <!DOCTYPE html>
        <html lang="en" style={'${fullHeight ? 'height: 100%;' : ''}'}>
          <head>
            <meta charset="utf-8">
            ${styles}
          </head>
          <body style={'${fullHeight ? 'height: 100%;' : ''}'}>
            ${html}
          </body>
      </html>
    `;
  };

  getVehiclesPdf = () => {
    const vehiclesJsx = (
      <div className='documents-container invisible'>
        {this.getSelectedItems().concat(this.state.newVehicleSelected ? [{
          ...this.state.newVehicle,
          make: {
            make: {
              name: this.state.newVehicle.make
            },
            model: {
              name: this.state.newVehicle.model
            },
            year: this.state.newVehicle.year,
          },
          stock_number: this.state.newVehicle.numberOfInventory
        }] : [] ).map(vehicle => (
          <VehicleInfo
            key={vehicle.id}
            vehicle={vehicle}
            account={this.state.accounts.filter((account => account.isSelected))[0]}
          />
        ))}
      </div>
    );

    return ReactDOMServer.renderToString(vehiclesJsx);
  };

  downloadPdfFromBrowser = (blob) => {
    const data = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = data;
    link.download = `vehicle_pdf_${new Date().getTime()}.pdf`;
    link.click();
    setTimeout(() => {
        window.URL.revokeObjectURL(data);
      }, 100
    );
  };

  loadableFunction = (callback) => {
    this.props.toggleLoading(true);

    callback()
      .then(() => {
        this.props.toggleLoading(false);
      })
  };

  handlePDFRequest = () => {
    this.loadableFunction(() => {
      return Api.generatePdf(this.getPdfDocument({html: this.getVehiclesPdf(), styles: styleText}))
        .then(this.downloadPdfFromBrowser);
    });
  };

  handleDacoPDFRequest = () => {
    this.loadableFunction(() => {
      return Api.generatePdf(this.getPdfDocument({html: this.genereateDacoReport(), fullHeight: true}))
        .then(this.downloadPdfFromBrowser);
    });
  };

  handleLogOut = () => {
    this.logOutUser();
  };

  logOutUser = () => {
    Auth.logout();
    this.props.history.push('/login');
  };

  handleInputChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };

  getFilteredVehicles = () => {
    const keyword = this.state.search.toLowerCase();

    return this.state.vehicles[this.state.accountId].filter((vehicle) => {
      const title = vehicle.title !== null && vehicle.title !== undefined ? vehicle.title.toLowerCase() : '';
      const vin = vehicle.vin !== null && vehicle.vin !== undefined ? vehicle.vin.toLowerCase() : '';

      return title.includes(keyword) || vin.includes(keyword)
    });
  };

  clearFilter = () => this.setState({ search: '' });

  updateFieldsValidator = (prop, value, oldValue) => {
      switch (prop) {
        case 'mileage':
        case 'price': {
          if (value === '') {
            return value
          }

          const newValue = parseInt(value);

          return isNaN(newValue) ? oldValue : newValue;
        }
        default: {
          return value;
        }
      }
    };

  handleVehicleInputChange = (id, prop, event) => {
    const newVehicles = {
      ...this.state.vehicles,
      [this.state.accountId]: this.state.vehicles[this.state.accountId].map((vehicle) => {
        return vehicle.id === id ? {
          ...vehicle,
          [prop]: this.updateFieldsValidator(prop, event.target.value, vehicle[prop])
        } : { ...vehicle }
      })
    };

    this.setState({ vehicles: newVehicles });
  };

  handleNewVehicleInputChange = (id, prop, event) => {
    this.setState({ newVehicle: {
      ...this.state.newVehicle,
      [prop]: this.updateFieldsValidator(prop, event.target.value, this.state.newVehicle[prop])
    } });
  }

  getHeaderButtonsData = () => {
    let areItemsSelected = this.areItemsSelected() || this.state.newVehicleSelected;

    return [
      {
        onClick: this.handleLogOut,
        text: 'Desconectarse',
        isDisabled: false
      },
      {
        onClick: this.handlePDFRequest,
        text: 'Generar PDF',
        isDisabled: !areItemsSelected,
        isDropdown: true,
      },
      {
        onClick: this.handleClearSelection,
        text: 'Limpiar Selección',
        isDisabled: !areItemsSelected
      },
    ]
  };

  onAccountSelected = (account) => {
    this.setState({ accountId: account.id });

    if (this.state.vehicles[account.id].length === 0) {
      this.fetchVehicles(account.id);
    }
  };

  dacoInput = (label, value) => (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '20px' }}>
      <span style={{ marginRight: '20px', minWidth: '150px', display: 'block', textAlign: 'right' }}>{label}</span>
      <div style={{
        flex: 1,
        height: '15px',
        border: '#000 1px solid',
        display: 'flex',
        alignItems: 'center',
        padding: '20px',
      }}>
        {value}
      </div>
    </div>
  );

  genereateDacoReport = () => {
    const vehicles =  this.getSelectedItems().concat(this.state.newVehicleSelected ? [{
          ...this.state.newVehicle,
          make: {
            make: {
              name: this.state.newVehicle.make
            },
            model: {
              name: this.state.newVehicle.model
            },
            year: this.state.newVehicle.year
          },
          stock_number: this.state.newVehicle.numberOfInventory
        }] : [] );

    const jsx =
      vehicles.map(vehicle => (
        <div style={{
          maxWidth: '1024px',
          backgroundImage: `url(${process.env.REACT_APP_SERVER_URL}${dacoWatermark})`,
          backgroundRepeat: 'repeat',
          backgroundSize: '200px',
          height: '100%',
          pageBreakBefore: 'always',
          backgroundColor: '#ffffff',
          padding: '40px 60px 80px',
        }}>
          <div style={{
            border: '#000 1px solid',
            maxWidth: '900px',
            margin: '0 auto',
            padding: '40px 60px'
          }}>
            <p style={{ margin: '0 auto' }}>
              Esta etiqueta se adhiere a este vehículo en cumplimiento de la Regla 11 A(B) del Reglamento Contra
              Prácticas y Anuncios Engañosos del Departamento de Asuntos del Consumidor, aprobado el 28 de mayo de 2015
            </p>
            <div style={{ marginTop: '50px' }}>
              {this.dacoInput('Marca:', _get(vehicle, 'make.make.name'))}
              {this.dacoInput('Modelo:', _get(vehicle, 'make.model.name'))}
              {this.dacoInput('VIN:', _get(vehicle, 'vin'))}
              {this.dacoInput('Stock #:', _get(vehicle, 'stock_number'))}
              {this.dacoInput('Precio de Venta:', vehicle && vehicle.price ? Number(vehicle.price.toFixed(2)).toLocaleString() : 0)}
            </div>
            <p style={{ marginTop: '40px' }}>
              Como se indica el precio indicado anteriormente no incluye costos como tablilla y/o gastos de inscripción,
              gastos de procesamiento, accesorios adicionales solicitados por el cliente, intereses de nacimiento entre
              otros.
            </p>
            <hr/>
            <p>
              En la regla 11A así como el informe adjunto al mismo, requiere que un vehículo en exhibición muestre
              claramente el “Precio de Venta del Concesionario” el cual se indica en la página 100 del informe es: “el
              precio
              a que este vendría, sin considerar variables como el vehículo entregado en trade-in, si se paga cash o se financia la compra.
            </p>
            <div style={{
              display: 'flex',
              flexDirection: 'row-reverse',
              marginBottom: '-52px',
              marginRight: '-60px',
              zIndex: 10000
            }}>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center'
              }}>
                <img style={{width: '100%'}} src={process.env.REACT_APP_SERVER_URL + dacoLogo}/>
              </div>
            </div>
          </div>
        </div>
      ));

    return ReactDOMServer.renderToString(jsx);
  };

  render() {
    if (!Object.keys(this.state.vehicles).length) {
      return null;
    }

    const selectedVehicles = this.getSelectedItems();
    const filteredVehicles = this.state.search && this.state.vehicles[this.state.accountId].length ? this.getFilteredVehicles() : this.state.vehicles[this.state.accountId];

    return (
      <Fragment>
        <NavBar
          accounts={this.state.accounts}
          onItemSelected={this.onAccountSelected}
        />
        <div className="container">
          <div className="card-panel vehicles-container">
            <div className="collection with-header">
              <div className="collection-header">
                <h4>Vehículos {selectedVehicles.length > 0 ? `- ${selectedVehicles.length} seleccionados` : ''}</h4>
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                {this.getHeaderButtonsData().map(({ isDisabled, text, onClick, isDropdown }, index) => {
                  if (isDropdown) {
                    return (
                      <div key={index}>
                        <a
                          style={{ minWidth: '173px' }}
                          className={`dropdown-trigger btn ${isDisabled ? 'disabled' : ''}`}
                          href='#'
                          data-target='dropdown1'>
                          {text}
                        </a>
                        <ul id='dropdown1' className='dropdown-content'>
                          <li><a href="#!" onClick={onClick}>Vehículos usados: Garantía y Condición</a></li>
                          <li><a href="#!" onClick={this.handleDacoPDFRequest}>Vehículos nuevos: DACO Regla 11
                            A(B)</a>
                          </li>
                        </ul>
                      </div>
                    )
                  } else {
                    return (
                      <Button
                        key={index}
                        onClick={onClick}
                        text={text}
                        isDisabled={isDisabled}
                      />
                    )
                  }
                })}
              </div>
              <div style={{ marginTop: 0, display: 'flex', justifyContent: 'flex-end' }}>
                <div className="input-field">
                  <input id="search" placeholder="Buscar por VIN o nombre del carro..." type="text"
                         value={this.state.search}
                         onChange={this.handleInputChange}/>
                </div>
                {this.state.search &&
                <div className='waves-effect icon-container' onClick={this.clearFilter}>
                  <i className="material-icons">clear</i>
                </div>
                }
              </div>
              <table>
                <thead>
                <tr>
                  {VehiclesPage.headers.map((label) => (
                    <th key={label}>{label}</th>
                  ))}
                </tr>
                </thead>
                <tbody>
                  <tr
                      className={`collection-item ${this.state.newVehicleSelected ? 'active' : ''}`}
                      // onClick={() => this.handleNewVehicleClick()}
                      data-id={'custom'}
                      key={this.state.accountId + 'custom'}
                    >
                      <td className='quarter-width'>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                          <p>
                            <label>
                              <input type="checkbox" className="filled-in" checked={this.state.newVehicleSelected}
                                     onChange={() => this.handleNewVehicleClick()}/>
                              <span/>
                            </label>
                          </p>
                          <ul>
                            <li key="1"><input
                              className={ `${this.isNewVehicleSelected() ? 'selected' : ''}` } type="text"
                              value={ this.state.newVehicle.make ? this.state.newVehicle.make : '' }
                              onChange={ (text) => this.handleNewVehicleInputChange('custom', 'make', text) }
                              placeholder={ 'Marca' }
                            /> <input
                              className={ `${this.isNewVehicleSelected() ? 'selected' : ''}` } type="text"
                              value={ this.state.newVehicle.model ? this.state.newVehicle.model : '' }
                              onChange={ (text) => this.handleNewVehicleInputChange('custom', 'model', text) }
                              placeholder={ 'Modelo' }
                            />
                            <input
                              className={ `${this.isNewVehicleSelected() ? 'selected' : ''}` } type="text"
                              value={ this.state.newVehicle.year ? this.state.newVehicle.year : '' }
                              onChange={ (text) => this.handleNewVehicleInputChange('custom', 'year', text) }
                              placeholder={ 'Year' }
                            /></li>
                            <li key="2"><input
                              className={ `${this.isNewVehicleSelected() ? 'selected' : ''}` } type="text"
                              value={ this.state.newVehicle.vin ? this.state.newVehicle.vin : '' }
                              onChange={ (text) => this.handleNewVehicleInputChange('custom', 'vin', text) }
                              placeholder={ 'VIN' }
                            /></li>
                          </ul>
                        </div>
                      </td>
                      <TableInput
                        value={this.state.newVehicle.numberOfInventory}
                        isItemSelected={this.isNewVehicleSelected()}
                        onChange={(text) => this.handleNewVehicleInputChange('custom', 'numberOfInventory', text)}
                        placeholder={'Número de Inventario'}
                      />
                      <TableInput
                        value={this.state.newVehicle.mileage}
                        isItemSelected={this.isNewVehicleSelected()}
                        onChange={(text) => this.handleNewVehicleInputChange('custom', 'mileage', text)}
                        placeholder={'Millage'}
                      />
                      <TableInput
                        value={this.state.newVehicle.clapBoard}
                        isItemSelected={this.isNewVehicleSelected()}
                        onChange={(text) => this.handleNewVehicleInputChange('custom', 'clapBoard', text)}
                        placeholder={'Tablilla'}
                      />
                      <TableInput
                        value={this.state.newVehicle.price}
                        isItemSelected={this.isNewVehicleSelected()}
                        onChange={(text) => this.handleNewVehicleInputChange('custom', 'price', text)}
                        placeholder={'Precio'}
                      />
                    </tr>
                {filteredVehicles.map((vehicle) => {
                  const isItemSelected = this.isItemSelected(vehicle.id);

                  return (
                    <tr
                      className={`collection-item ${isItemSelected ? 'active' : ''}`}
                      onClick={() => this.handleItemClick(vehicle)}
                      data-id={vehicle.id}
                      key={this.state.accountId + vehicle.id}
                    >
                      <td className='quarter-width'>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                          <p>
                            <label>
                              <input type="checkbox" className="filled-in" checked={isItemSelected}
                                     onChange={() => this.handleItemClick(vehicle)}/>
                              <span/>
                            </label>
                          </p>
                          <ul>
                            <li>{vehicle.title}</li>
                            <li>{_get(vehicle, 'color.name')}</li>
                            <li>{vehicle.vin}</li>
                          </ul>
                        </div>
                      </td>
                      <TableInput
                        value={vehicle.numberOfInventory}
                        isItemSelected={isItemSelected}
                        onChange={(text) => this.handleVehicleInputChange(vehicle.id, 'numberOfInventory', text)}
                        placeholder={'Número de Inventario'}
                      />
                      <TableInput
                        value={vehicle.mileage}
                        isItemSelected={isItemSelected}
                        onChange={(text) => this.handleVehicleInputChange(vehicle.id, 'mileage', text)}
                        placeholder={'Millage'}
                      />
                      <TableInput
                        value={vehicle.clapBoard}
                        isItemSelected={isItemSelected}
                        onChange={(text) => this.handleVehicleInputChange(vehicle.id, 'clapBoard', text)}
                        placeholder={'Tablilla'}
                      />
                      <TableInput
                        value={vehicle.price}
                        isItemSelected={isItemSelected}
                        onChange={(text) => this.handleVehicleInputChange(vehicle.id, 'price', text)}
                        placeholder={'Precio'}
                      />
                    </tr>
                  );
                })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default VehiclesPage;



// WEBPACK FOOTER //
// ./src/pages/vehicles/index.js